<template>
    <div class="container">
        <div class="row" v-if="! registered">
            <div class="col-md-6" >
                <h2 class="">Register</h2>
            </div>
        </div>
        <div class="row justify-content-center" v-if="! registered">
            <div class="col-md-12 border-top pt-4">
                <form method="POST" novalidate @submit.prevent="submit">
                    <div class="row">
                        <div class="col-md-6">
                            <h4>User Details</h4>

                            <div class="form-group row">
                                <label for="first_name" class="col-md-4 col-form-label text-md-right">First Name</label>
                                <div class="col-md-8">
                                    <input id="first_name" type="text" class="form-control " name="first_name" required="required" autocomplete="first_name" autofocus
                                        :class="{'is-invalid': firstNameHasError}"
                                        :disabled="this.loading"
                                        v-model="first_name" >
                                    <form-error name="first_name" :errors="errors"></form-error>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="last_name" class="col-md-4 col-form-label text-md-right">Surname</label>
                                <div class="col-md-8">
                                    <input id="last_name" type="text" class="form-control " name="last_name" required="required" autocomplete="last_name"
                                        :class="{'is-invalid': lastNameHasError}"
                                        :disabled="this.loading" 
                                        v-model="last_name" >
                                    <form-error name="last_name" :errors="errors"></form-error>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="email" class="col-md-4 col-form-label text-md-right">E-Mail Address</label>
                                <div class="col-md-8">
                                    <input id="email" type="email" class="form-control " name="email" required="required" autocomplete="email"
                                        :class="{'is-invalid': emailHasError}"
                                        :disabled="this.loading" 
                                        v-model="email" >
                                    <form-error name="email" :errors="errors"></form-error>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="password" class="col-md-4 col-form-label text-md-right">Password</label>
                                <div class="col-md-8">
                                    <input id="password" type="password" class="form-control " name="password" required="required" autocomplete="new-password"
                                        :class="{'is-invalid': passwordHasError}" 
                                        :disabled="this.loading"
                                        v-model="password" >
                                    <form-error name="password" :errors="errors"></form-error>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="password-confirm" class="col-md-4 col-form-label text-md-right">Confirm Password</label>
                                <div class="col-md-8">
                                    <input id="password-confirm" type="password" class="form-control" name="password_confirmation" required="required" autocomplete="new-password"
                                        :class="{'is-invalid': passwordHasError}"
                                        :disabled="this.loading"
                                        v-model="password_confirmation" >
                                </div>
                                <small id="forceImageHelp" class="form-text text-muted">Password must be at least six characters long, contain at least one uppercase and lowercase character, one numeric digit and one special character such as !"£$%^</small>
                            </div>
                    
                        </div>

                        <div class="col-md-6">
                            <h4>Police Details</h4>

                            <div class="form-group row">
                                <label for="force" class="col-md-4 col-form-label text-md-right">Force</label>

                                <div class="col-md-8">
                                    <select class="custom-select " id="force" name="force" required="required" 
                                        :class="{'is-invalid': forceHasError}" 
                                        :disabled="this.loading"
                                        v-model="force">
                                        <option value="">--- Please Select ---</option>
                                        <option v-for="force in forces" :key="force.id" :value="force.id">
                                            {{ force.name }}
                                        </option>
                                    </select>
                                    <form-error name="force" :errors="errors"></form-error>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="default_lpa" class="col-md-4 col-form-label text-md-right">Default LPA</label>

                                <div class="col-md-8">
                                    <select class="custom-select" id="default_lpa" name="default_lpa" required="required"
                                        :class="{'is-invalid': lpaHasError}"
                                        :disabled="lpas.length === 0 || this.loading" 
                                        v-model="default_lpa">
                                        <option value="">--- Please Select ---</option>
                                        <option v-for="lpa in lpas" :key="lpa.id" :value="lpa.id">
                                            {{ lpa.name }}
                                        </option>
                                    </select>
                                    
                                    <form-error name="default_lpa" :errors="errors"></form-error>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="rank" class="col-md-4 col-form-label text-md-right">Rank</label>

                                <div class="col-md-8">
                                    <select class="custom-select " id="rank" name="rank" required="required" 
                                        :class="{'is-invalid': rankHasError}"
                                        :disabled="this.loading" 
                                        v-model="rank">
                                        <option value="">--- Please Select ---</option>
                                        <option v-for="rank in ranks" :key="rank.id" :value="rank.id">
                                            {{ rank.name }}
                                        </option>
                                    </select>
                                    <form-error name="rank" :errors="errors"></form-error>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="collar" class="col-md-4 col-form-label text-md-right">Collar</label>
                                <div class="col-md-8">
                                    <input id="collar" type="text" class="form-control " name="collar" required="required" autocomplete="collar"
                                        :class="{'is-invalid':collarHasError}"
                                        :disabled="this.loading" 
                                        v-model="collar">
                                    <form-error name="collar" :errors="errors"></form-error>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="telephone-extension" class="col-md-4 col-form-label text-md-right">Tel Ext.</label>
                                <div class="col-md-8">
                                    <input id="telephone-extension" type="text" class="form-control " name="telephone_extension" required autocomplete="telephone"
                                        :class="{'is-invalid':telephoneHasError}"
                                        :disabled="this.loading" 
                                        v-model="telephone_extension">
                                    <form-error name="telephone_extension" :errors="errors"></form-error>
                                </div>
                            </div>
                    
                        </div>
                    </div>

                    <div class="form-group row mb-0">
                        <div class="col-md-6 offset-md-5">
                            <button type="submit" class="btn btn-primary" v-if="! this.loading">Register</button>
                            <button type="submit"  class="btn btn-primary" disabled v-else>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Registering...
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row justify-content-center" v-else>
            <div class="col-md-8">
                <div class="card">
                    <div class="card-header">Registration Successful</div>
                    <div class="card-body">
                        You will receive an email with confirmation of your login details within 2 working days
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import CurrentUser from '../../../mixins/CurrentUser';
import FormError from "../../Util/FormError";
import AuthService from '../../../services/AuthService';

export default {

    data: function () {
        return {
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            password_confirmation: '',
            force: '',
            default_lpa: '',
            rank: '',
            collar: '',
            telephone_extension: '',
            errors: {},
            registered: true,
            loading: false,
        }
    },

    mixins: [CurrentUser],
    
    components: {
        FormError,
    },

    mounted() {
        this.reset();
    },

    watch: {
        force: function () {
            this.default_lpa = '';
        }
    },

    methods: {
        submit: function () {
            this.errors = {};
            this.loading = true;

            AuthService.register({ 
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                password: this.password,
                password_confirmation: this.password_confirmation,
                force: this.force,
                default_lpa: this.default_lpa,
                rank: this.rank,
                collar: this.collar,
                telephone_extension: this.telephone_extension,
            })
                .then( ({data}) => this.success(data) )
                .catch( ({response}) => this.failed(response) );
        },
        success: function () {
            this.reset();
            this.registered = true;
        },
        failed: function(response){
            this.loading = false;
            this.password = this.password_confirmation = '';
            this.errors = response.data.errors;
        },  
        reset: function () {
            this.first_name = this.last_name = this.email = this.password = this.password_confirmation = '';
            this.force = this.default_lpa = this.rank = this.collar = this.telephone_extension = '';
            this.errors = {};
            this.loading = this.registered = false;
        },
        hasError: function (key) {
            return (this.errors[key]);
        }
    },

    computed: {
        firstNameHasError: function() {  return this.hasError('first_name') },
        lastNameHasError: function() {  return this.hasError('last_name') },
        emailHasError: function() {  return this.hasError('email') },
        passwordHasError: function() {  return this.hasError('password') },
        forceHasError: function() {  return this.hasError('force') },
        rankHasError: function() {  return this.hasError('rank') },
        collarHasError: function() {  return this.hasError('collar') },
        telephoneHasError: function() {  return this.hasError('telephone_extension') },
        lpaHasError: function() {  return this.hasError('default_lpa') },
        forces: function () {
            return this.$store.state.forces.data;  
        },
        ranks: function () {
            return this.$store.state.ranks.data;  
        },
        lpas: function () {
            if (this.force === '') {
                return [];
            }

            return this.forces.filter(force => force.id === this.force)[0].lpas;  
        },
    }
}
</script>

